var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-container btn btn-outline-secondary",on:{"click":function($event){return _vm.$emit('abrir')}}},[_c('i',{staticClass:"fas fa-cog"})])}
var staticRenderFns = []

export { render, staticRenderFns }